import styled from 'styled-components/macro';
import * as colors from '../../../common/colorConstants';

export const TopContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
`;

export const Title = styled.h2`
  margin-top: 0;
  margin-bottom: 16px;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: ${colors.black4};
`;

export const ReasonContainer = styled.div`
  padding: 32px;
`;

export const Placeholder = styled.div`
  height: calc(100% - 70px);
`;
